<template>
  <section
    class="flex h-full w-full flex-col justify-between gap-4 rounded-md border border-light-gray p-4"
  >
    <h3 class="text-left text-base text-dark-gray lg:text-xl">Endorsements</h3>
    <div class="flex w-full flex-col gap-4 lg:flex-row">
      <sizes
        class="flex-1"
        :size="size"
      />
      <credit-approval
        :credit-approval="creditApproval"
        class="flex-1"
      />
      <Affiliations
        class="flex-1"
        :affiliations="affiliations"
      />
    </div>
  </section>
</template>

<script setup>
import { defineProps } from 'vue';
import Sizes from '@/components/show/Sizes.vue';
import CreditApproval from '@/components/show/CreditApproval.vue';
import Affiliations from '@/components/show/Affiliations.vue';

defineProps({
  creditApproval: {
    type: String,
    required: true,
    default: 'unknown',
  },
  affiliations: {
    type: Object,
    required: true,
    default: () => ({}),
  },
  size: {
    type: String,
    required: true,
    default: 'unknown',
  },
});
</script>
